window.LoopService = window.LoopService || {};

window.LoopService.Base = {
  getDigitalOceanBaseUrl: () => {
    const baseUrl = window.LoopConfig.DIGITAL_OCEAN_BASE_URL;
    if (!baseUrl) {
      throw new Error("baseUrl is not configured");
    }
    return baseUrl;
  },

  retrieveAuthHeader: async () => {
    try {
      const token = await window.ClerkUtils.getToken();

      if (!token) {
        console.warn("[auth] Clerk session ready but token is empty");
        return null;
      }

      return { key: "Authorization", value: `Bearer ${token}` };
    } catch (err) {
      console.warn(
        "[auth] Failed to get Clerk token, skipping auth header:",
        err
      );
      return null;
    }
  },

  shouldIncludeCredentials: (url) => {
    // Only include credentials for relative urls.
    return !/^https?:\/\//i.test(url);
  },

  makeAuthenticatedRequest: async (url, options = {}) => {
    const authHeader = await window.LoopService.Base.retrieveAuthHeader();

    if (!authHeader) {
      const err = new Error("[auth] Missing auth header for " + url);
      err.code = "NO_AUTH_HEADER";
      throw err;
    }

    const headers = new Headers({
      accept: "application/json",
      ...(options.headers || {}),
    });
    headers.set(authHeader.key, authHeader.value);

    const credentials = window.LoopService.Base.shouldIncludeCredentials(url)
      ? "include"
      : "omit";

    const response = await fetch(url, {
      ...options,
      headers,
      credentials,
    });

    if (!response.ok) {
      const error = new Error(
        `API request failed: ${response.status} ${response.statusText}`
      );
      error.status = response.status;
      error.url = url;
      throw error;
    }

    return response;
  },
};
